import script from "./NumberTagsDeleteDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NumberTagsDeleteDialog.vue?vue&type=script&setup=true&lang=js"

import "./NumberTagsDeleteDialog.vue?vue&type=style&index=0&id=9f0d69a0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f0d69a0"]])

export default __exports__